export default function IcoCloseError() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
				fill="#E4204E"
				stroke="#E4204E"
				strokeLinecap="round"
			/>
			<path
				d="M15 9L9.1701 14.8299M14.8359 15L9.00603 9.1701"
				stroke="white"
				strokeLinecap="round"
			/>
		</svg>
	);
}
